<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CYRxoN/tc-custom/9781504048064.jpg?1737331074539" alt="This image is the cover for the book Dangerous Woman"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dangerous Woman
      </h1>
      <p class="bookDescription body article font2">
        <b>The “compelling, suspenseful” novel of a vulnerable misfit in a small town by the <i>New York Times</i>–bestselling author of <i>Light from a Distant Star</i> (<i>Publishers Weekly</i>).</b><br/>  <br/> Named one of the five best novels of the year by <i>Time</i> magazine, <i>A Dangerous Woman</i> is the story of the damaged and emotionally unstable Martha Horgan, an outcast in her small Vermont town. She stares; she has violent crushes on people; and, perhaps most unsettling of all, she cannot stop telling the truth. After a traumatic experience during her teenage years, the thirty-two-year-old now craves love and companionship, but her relentless honesty makes her painfully vulnerable to those around her: Frances, her wealthy aunt and begrudging guardian; Birdy Dusser, who befriends her and then cruelly rejects her; and Colin Mackey, the seductive man who preys on her desires.<br/>  <br/> Confused and bitter, distrusting even those with her best interests at heart, Martha is slowly propelled into a desperate attempt to gain control over her own life. The National Book Award–nominated author of <i>Songs in Ordinary Time </i>tells a tale of unnerving suspense and terrifying psychological insight that is “at once thrilling and deeply affecting” (<i>The New York Times</i>).<br/><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary McGarry Morris
      </h2>
      
      <p class="authorDescription body article">Mary McGarry Morris grew up in Vermont and now lives on the North Shore in Massachusetts. Her first novel, <I>Vanished</I>, was published in 1988 and was nominated for the National Book Award and the PEN/Faulkner Award. <I>A Dangerous Woman</I> (1991) was chosen by<I> Time</I> magazine as one of the &ldquo;Five Best Novels of the Year&rdquo; and was made into a motion picture starring Debra Winger, Barbara Hershey, and Gabriel Byrne.<I> Songs in Ordinary Time</I> (1995) was an Oprah&rsquo;s Book Club selection, which propelled it to the top of the <I>New York Times</I> bestseller list for many weeks, and it was adapted for a TV movie starring Sissy Spacek and Beau Bridges. Morris&rsquo;s other highly acclaimed works include the novels <I>Fiona Range</I> (2000), <I>A Hole in the Universe</I> (2004), <I>The Lost Mother</I> (2005), <I>The Last Secret</I> (2009), and <I>Light from a Distant Star</I> (2011), as well as the play <I>MTL: The Insanity File</I>.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?38dde499